var chunkToChildrenMap = {
	"default-node_modules_date-fns_index_js": [
		"src_app_email-to-friend_email-to-friend_component_ts",
		"src_app_forward-message_forward-message_component_ts",
		"src_app_shared_components_message-actions_message-actions_component_ts"
	],
	"src_app_vnc-fluid_vnc-fluid_module_ts": [
		"common",
		"src_app_quick-preview_quick-preview_component_ts",
		"default-src_app_mail-operation-compose_mail-operation-compose_component_ts",
		"default-src_app_chat-preview_chat-preview_component_ts",
		"src_app_update-avatar_update-avatar_component_ts",
		"src_app_vnc-fluid_add-participants_add-participants_component_ts",
		"src_app_vnc-fluid_create-workspace_create-workspace_component_ts"
	],
	"src_app_quick-preview_quick-preview_component_ts": [
		"default-src_app_mail-operation-compose_mail-operation-compose_component_ts"
	],
	"src_app_doc-preview_doc-add-tag_doc-add-tag_component_ts": [
		"src_app_doc-preview_doc-add-tag_color-control-dialog_color-control-dialog_component_ts"
	],
	"default-src_app_chat-preview_chat-preview_component_ts": [
		"src_app_email-to-friend_email-to-friend_component_ts",
		"src_app_forward-message_forward-message_component_ts",
		"src_app_shared_components_message-actions_message-actions_component_ts"
	],
	"src_app_task-preview_task-preview_component_ts": [
		"default-src_app_task-compose_index_ts"
	],
	"src_app_start-group-chat_start-group-chat_component_ts": [
		"default-src_app_chat-preview_chat-preview_component_ts",
		"default-node_modules_date-fns_index_js",
		"src_app_select-participant-group-chat_select-participant-group-chat_component_ts",
		"src_app_update-avatar_update-avatar_component_ts"
	],
	"src_app_create-new-dialog_create-new-dialog_component_ts": [
		"common",
		"src_app_compose-incident_compose-incident_component_ts",
		"src_app_compose-mail_compose-mail_component_ts",
		"src_app_compose-ticket_compose-ticket_component_ts",
		"default-src_app_task-compose_index_ts"
	],
	"src_app_vnc-fluid_create-workspace_create-workspace_component_ts": [
		"src_app_update-avatar_update-avatar_component_ts",
		"src_app_vnc-fluid_add-participants_add-participants_component_ts"
	],
	"src_app_shared_components_message-actions_message-actions_component_ts": [
		"src_app_forward-message_forward-message_component_ts"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));